import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { ParametrosService } from 'app/services/parametros.service';
import { take } from 'rxjs';
import moment from 'moment';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';

export interface PeriodicElement {
    id: string;
    fechaingreso: Date;
    folioInicial: string;
    folioFinal: string;
    total: number;
    fechaVencimiento: Date;
    estado: string;
}

@Component({
    selector: 'folios',
    templateUrl: './folios.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./folios.component.scss'],
    animations: fuseAnimations,
})
export class FoliosComponent {
    constructor(private route: Router, private _ParametrosService: ParametrosService) {}

    //date = new FormControl(new Date());
    modalFolios: boolean = false;
    modalEliminar: boolean = false;
    showGuardar: boolean = false;
    showAlert: boolean = false;
    showAlertEliminar: boolean = false;
    foliosDisponibles: number = 0;
    proximoFolio: number = 0;
    idMaximo: number = 0;
    folioMaximo: number = 0;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    handleModalFoliosClose(): void {
        this.showGuardar = false;
        this.modalFolios = false;
        this.alert = {
            type: 'error',
            message: '',
        };
        this.showAlert = false;
    }
    arrayfolio = null;
    ngOnInit(): void {
        this._ParametrosService
            .getFolio()
            .pipe(take(1))
            .subscribe({
                next: (folio) => {
                    //console.log(folio);
                    this.arrayfolio = folio;
                    let arrayDisp = [];
                    let enUso = [];
                    let vigente = [];
                    this.foliosDisponibles = 0;
                    folio.reduce((acc, item) => {
                        if (item.ID_ESTADO == 1) {
                            arrayDisp.push({ ESTADO: item.ID_ESTADO, FOLIO: item.ID_RANGO });
                            vigente.push(item.FOLIO_INICIAL);
                        }
                        if (item.ID_ESTADO == 1 || item.ID_ESTADO == 2) {
                            this.foliosDisponibles = this.foliosDisponibles + item.DISPONIBLES;
                        }
                        if (item.ID_ESTADO == 2) {
                            enUso.push(item.FOLIO_PROX_DISPONIBLE);
                        }

                        return acc;
                    }, {});
                    if (this.foliosDisponibles == 0) {
                        this.proximoFolio == 0;
                    } else if (folio.length == 1 && folio[0].FOLIO_PROX_DISPONIBLE == null) {
                        this.proximoFolio = 1;
                    } else if (enUso.length == 1) {
                        this.proximoFolio = enUso[0];
                    } else if (enUso.length == 0) {
                        this.proximoFolio = Math.min.apply(
                            Math,
                            vigente.map(function (o) {
                                return o;
                            })
                        );
                    } else {
                        this.proximoFolio = Math.max.apply(
                            Math,
                            enUso.map(function (o) {
                                return o;
                            })
                        );
                    }
                    this.dataSource = this.arrayfolio.map((elem) => ({
                        id: elem.ID_RANGO,
                        fechaingreso: elem.FECHA_INGRESO,
                        folioInicial: elem.FOLIO_INICIAL,
                        folioFinal: elem.FOLIO_FINAL,
                        total: elem.TOTAL,
                        fechaVencimiento: elem.FECHA_VENCIMIENTO,
                        estado: elem.ID_ESTADO,
                    }));
                    this.idMaximo = Math.max.apply(
                        Math,
                        folio.map(function (o) {
                            return o.ID_RANGO;
                        })
                    );
                    this.folioMaximo = Math.max.apply(
                        Math,
                        folio.map(function (o) {
                            return o.FOLIO_FINAL;
                        })
                    );
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }

    handleGuardar(): void {
        this.showGuardar = true;

        setTimeout(() => {
            this.showGuardar = false;
        }, 3000);
    }

    goback(): void {
        this.route.navigateByUrl('home/sistema');
    }

    columns: TableColumn[] = [
        {
            columnDef: 'id',
            header: 'ID',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'fechaingreso',
            header: 'FECHA INGRESO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY',
            columnSort: true,
        },
        {
            columnDef: 'folioInicial',
            header: 'FOLIO INICIAL',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'folioFinal',
            header: 'FOLIO FINAL',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'total',
            header: 'TOTAL',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'number',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'fechaVencimiento',
            header: 'FECHA VENCIMIENTO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY',
            columnSort: true,
        },
        {
            columnDef: 'estado',
            header: 'ESTADO',
            headerClass: 'text-left px-1.5',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'flex items-center gap-2',
            columnType: 'custom',
            columnFormat: '',
            columnSort: true,
            columFunction: this.printEstado,
        },
    ];
    public customPatterns = { '0': { pattern: new RegExp('^[0-9]{1,20}$') } };
    selection = new SelectionModel<any>(true, []);

    dataSource = [];
    folioInicial: number = null;
    folioFinal: number = null;
    date = new FormControl(new Date());

    onTableAction(row: any) {
        //console.log('ver detalles de', row);
        //console.log(row.id);
        this.route.navigateByUrl('/home/sistema/folios/detalle/' + row.id);
    }

    ejemploBorrarSeleccionados() {
        //console.log(this.selection.selected);
        let asd = this.selection.selected.map((elem) => ({
            id: elem.id,
            folioinicial: elem.folioInicial,
            folioFinal: elem.folioFinal,
            estado: elem.estado,
        }));
        if (asd.some((s) => s.estado == 2)) {
            this.alert = {
                type: 'error',
                message: 'No es posible eliminar, ya que el id se encuentra en uso',
            };
            this.showAlertEliminar = true;
        } else {
            this.dataSource = this.dataSource.filter((f) => !this.selection.selected.some((s) => s.id == f.id));
            this.selection = new SelectionModel<any>(true, []);
            this.modalEliminar = false;
            //console.log(this.selection.selected)
            this._ParametrosService
                .deleteRangoFolio(asd)
                .pipe(take(1))
                .subscribe({
                    next: (folio) => {
                        this._ParametrosService
                            .getFolio()
                            .pipe(take(1))
                            .subscribe({
                                next: (folio) => {
                                    //console.log(folio);
                                    this.arrayfolio = folio;
                                    let arrayDisp = [];
                                    let enUso = [];
                                    let vigente = [];
                                    this.foliosDisponibles = 0;
                                    folio.reduce((acc, item) => {
                                        if (item.ID_ESTADO == 1) {
                                            arrayDisp.push({ ESTADO: item.ID_ESTADO, FOLIO: item.ID_RANGO });
                                            vigente.push(item.FOLIO_INICIAL);
                                        }
                                        if (item.ID_ESTADO == 1 || item.ID_ESTADO == 2) {
                                            this.foliosDisponibles = this.foliosDisponibles + item.DISPONIBLES;
                                        }
                                        if (item.ID_ESTADO == 2) {
                                            enUso.push(item.FOLIO_PROX_DISPONIBLE);
                                        }

                                        return acc;
                                    }, {});
                                    if (this.foliosDisponibles == 0) {
                                        this.proximoFolio == 0;
                                    } else if (folio.length == 1 && folio[0].FOLIO_PROX_DISPONIBLE == null) {
                                        this.proximoFolio = 1;
                                    } else if (enUso.length == 1) {
                                        this.proximoFolio = enUso[0];
                                    } else if (enUso.length == 0) {
                                        this.proximoFolio = Math.min.apply(
                                            Math,
                                            vigente.map(function (o) {
                                                return o;
                                            })
                                        );
                                    } else {
                                        this.proximoFolio = Math.max.apply(
                                            Math,
                                            enUso.map(function (o) {
                                                return o;
                                            })
                                        );
                                    }
                                    this.dataSource = this.arrayfolio.map((elem) => ({
                                        id: elem.ID_RANGO,
                                        fechaingreso: elem.FECHA_INGRESO,
                                        folioInicial: elem.FOLIO_INICIAL,
                                        folioFinal: elem.FOLIO_FINAL,
                                        total: elem.TOTAL,
                                        fechaVencimiento: elem.FECHA_VENCIMIENTO,
                                        estado: elem.ID_ESTADO,
                                    }));
                                    this.idMaximo = Math.max.apply(
                                        Math,
                                        folio.map(function (o) {
                                            return o.ID_RANGO;
                                        })
                                    );
                                    this.folioMaximo = Math.max.apply(
                                        Math,
                                        folio.map(function (o) {
                                            return o.FOLIO_FINAL;
                                        })
                                    );
                                },
                                error: (err) => {
                                    console.log(err);
                                },
                                complete: () => {},
                            });
                    },
                    error: (err) => {
                        console.log(err);
                    },
                    complete: () => {},
                });
        }
    }
    guardarNuevoFolio() {
        this.alert = {
            type: 'error',
            message: '',
        };
        this.showAlert = false;
        //log(this.folioInicial);
        let fecha = new Date(this.date.value);
        let infoFolio = {
            ultimoID: this.idMaximo,
            folioInicial: this.folioInicial,
            folioFinal: this.folioFinal,
            fechaIngreso: moment(fecha).format(),
            fechaVencimiento: moment(fecha).add(6, 'months').format(),
        };
        if (Number(this.folioInicial) > Number(this.folioFinal)) {
            this.folioInicial = null;
            this.folioFinal = null;
            this.alert = {
                type: 'error',
                message: 'Valor inicial no puede ser mayor que el valor final.',
            };
            this.showAlert = true;
        } else if (Number(this.folioInicial) < Number(this.folioMaximo)) {
            this.alert = {
                type: 'error',
                message: 'Valor ya se encuentra dentro de los rangos',
            };
            this.showAlert = true;
            this.folioInicial = null;
            this.folioFinal = null;
        } else {
            this._ParametrosService
                .createNewRangoFolio(infoFolio)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        // console.log('salida', data);
                        this.alert = {
                            type: 'success',
                            message: 'Rango creado exitosamente',
                        };
                        this.folioInicial = null;
                        this.folioFinal = null;
                        this.showAlert = true;
                        this._ParametrosService
                            .getFolio()
                            .pipe(take(1))
                            .subscribe({
                                next: (folio) => {
                                    //console.log(folio);
                                    this.arrayfolio = folio;
                                    let arrayDisp = [];
                                    let enUso = [];
                                    let vigente = [];
                                    this.foliosDisponibles = 0;
                                    folio.reduce((acc, item) => {
                                        if (item.ID_ESTADO == 1) {
                                            arrayDisp.push({ ESTADO: item.ID_ESTADO, FOLIO: item.ID_RANGO });
                                            vigente.push(item.FOLIO_INICIAL);
                                        }
                                        if (item.ID_ESTADO == 1 || item.ID_ESTADO == 2) {
                                            this.foliosDisponibles = this.foliosDisponibles + item.DISPONIBLES;
                                        }
                                        if (item.ID_ESTADO == 2) {
                                            enUso.push(item.FOLIO_PROX_DISPONIBLE);
                                        }

                                        return acc;
                                    }, {});
                                    if (this.foliosDisponibles == 0) {
                                        this.proximoFolio == 0;
                                    } else if (folio.length == 1 && folio[0].FOLIO_PROX_DISPONIBLE == null) {
                                        this.proximoFolio = 1;
                                    } else if (enUso.length == 1) {
                                        this.proximoFolio = enUso[0];
                                    } else if (enUso.length == 0) {
                                        this.proximoFolio = Math.min.apply(
                                            Math,
                                            vigente.map(function (o) {
                                                return o;
                                            })
                                        );
                                    } else {
                                        this.proximoFolio = Math.max.apply(
                                            Math,
                                            enUso.map(function (o) {
                                                return o;
                                            })
                                        );
                                    }
                                    this.dataSource = this.arrayfolio.map((elem) => ({
                                        id: elem.ID_RANGO,
                                        fechaingreso: elem.FECHA_INGRESO,
                                        folioInicial: elem.FOLIO_INICIAL,
                                        folioFinal: elem.FOLIO_FINAL,
                                        total: elem.TOTAL,
                                        fechaVencimiento: elem.FECHA_VENCIMIENTO,
                                        estado: elem.ID_ESTADO,
                                    }));
                                    this.idMaximo = Math.max.apply(
                                        Math,
                                        folio.map(function (o) {
                                            return o.ID_RANGO;
                                        })
                                    );
                                    this.folioMaximo = Math.max.apply(
                                        Math,
                                        folio.map(function (o) {
                                            return o.FOLIO_FINAL;
                                        })
                                    );
                                },
                                error: (err) => {
                                    console.log(err);
                                },
                                complete: () => {},
                            });
                    },
                    error: (err) => {
                        console.log(err);
                        this.alert = {
                            type: 'error',
                            message: 'No se pudo crear rango',
                        };
                        this.showAlert = true;
                        this.folioInicial = null;
                        this.folioFinal = null;
                    },
                    complete: () => {},
                });
        }

        // console.log(this.ID)
    }

    printEstado(row: any, attribute: string): string {
        let dict = {
            1: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    VIGENTE
                    </p>
                </div>
            </div>`,
            4: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    VENCIDO
                    </p>
                </div>
            </div>`,
            3: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
            2: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-02">
                    <p class="paragraph-tag_upper text-primary-white-01">
                    EN USO
                    </p>
                </div>
            </div>`,
        };
        return dict[row[attribute]] || '';
    }

    printEstadoMobile(attribute: string): string {
        let dict = {
            1: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    VIGENTE
                    </p>
                </div>
            </div>`,
            4: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    VENCIDO
                    </p>
                </div>
            </div>`,
            3: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
            2: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-02">
                    <p class="paragraph-tag_upper text-primary-white-01">
                    EN USO
                    </p>
                </div>
            </div>`,
        };
        return dict[attribute] || '';
    }

    hasItem(usuario: PeriodicElement) {
        return this.selection.selected.some(({ id }) => {
            return id === usuario.id;
        });
    }

    handleClick(usuario: PeriodicElement): void {
        let payload: PeriodicElement[] = [];

        const checked = this.selection.selected.some(({ id }) => {
            return id === usuario.id;
        });

        if (!checked) {
            payload = [...this.selection.selected, usuario];
        } else {
            payload = this.selection.selected.filter(({ id }) => id !== usuario.id);
        }

        this.selection = new SelectionModel<any>(true, [...payload]);
    }
}
